<template>
    <!-- 抽奖主体页 -->
    <div>
        <img class="box-img"
            :style="{ 'margin': `${marginTopValue} auto 0` }"
            :src="drawWheelUrl">
        <div v-if="isShowRank"
            class="integral">
            <div v-if="isExceedTotalTimes">{{ pageDisplayContent }}</div>
            <template v-else>
              <div>{{drawPointConsumption}}积分/次</div>
              <div>您剩余积分：{{ balancePonits !== 'undefined' ? balancePonits : "" }}</div>
            </template>
        </div>
        <div v-if="isShowDegree"
            class="step-times">
            <div v-if="tips">{{ tips }}</div>
            <div v-else> 剩余抽奖次数{{ participateTimes }}</div>
        </div>
        <div v-if="isShowLogin"
            class="button"
            :style="buttonStyle">
            <div class="login-p">登录荣耀会员获得抽奖机会</div>
            <div class="go-login"
                @click="goHiHonorMiniProgram('index')"></div>
        </div>
        <div v-else
            :class="activityRunning ? 'button' : 'button button-mt'"
            :style="buttonStyle"
            @click="showPopupEndPage">
            {{ drawButtonText }}
        </div>
    </div>
</template>

<script>
import { BigWheelConstants as BWC } from '../../../../common/global-variable';

export default {
  props: {
    marginTopValue: String, // 主体到顶部的高度
    drawWheelUrl: String, // 主题可配置的图片
    isShowRank: Boolean, //是否显示积分详情
    drawPointConsumption: Number, // 单次抽奖积分数
    balancePonits: String, // 剩余积分数
    isShowDegree: Boolean, // 是否显示剩余次数
    tips: String, // 抽奖机会用完后展示文案
    participateTimes: Number, // 剩余可抽奖次数
    isShowLogin: Boolean, // 是否需要登录
    buttonStyle: Object, // 按钮样式
    activityRunning:Boolean, // 活动是否进行中 true 进行中 false 已结束
    drawButtonText:String, // 抽奖按钮文字
    // 用户的抽奖状态
    drawStatus: {
      type: String,
      default: ''
    },
    // 页面展示文案
    pageDisplayContent: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 积分抽奖，是否最大抽奖限制
    isExceedTotalTimes(){
      return this.drawStatus === BWC.status.exceedTotalTimes;
    },
  },
  methods:{
    goHiHonorMiniProgram(data){
        this.$emit('goHiHonorMiniProgram',data)
    },
    showPopupEndPage(){
        this.$emit('showPopupEndPage')
    }
  }
};
</script>
<style lang="scss" scoped>
.box-img {
  width: 61.3%;
  height: 39vh;
  display: block;
  animation: bounce-down 1.6s linear infinite;
}
@keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-4px);
  }
  50%,
  100% {
    -webkit-transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(4px);
  }
}
.integral {
  margin-top: 3.3vh;
  font-size: 14px;
  color: #181818;
  text-align: center;
  font-weight: 400;
}
.step-times {
  font-size: 19px;
  font-weight: 500;
  text-align: center;
  margin-top: 3.3vh;
}
.button {
  position: relative;
  background-size: cover;
  width: 65%;
  font-size: 16px;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  line-height: 47px;
  margin: 2.5vh auto 0;
  border-radius: 24px;
  .login-p {
    position: relative;
  }
  .go-login {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
.button-mt{
  margin-top: 10.6vh;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/new-blind-box/components/public/principal-part.vue